

export const APP_VERSION = '1.0.0'; // Application version
export const ITEMS_PER_PAGE = 8;

// const APP_NAME = 'PrimeDocs'; // Application name